<template>
  <div class="mt-lg">
    <div>
      <div class="flex gap-base sm:gap-none flex-col sm:flex-row sm:items-center justify-between">
        <h3 class="m-0">{{ title }}</h3>
        <div
            class="flex items-center gap-base"
            data-test="controls"
        >
          <label class="text-12 text-dark3">{{ $t('library.feeds.extendableFeed.utcToggle') }}</label>
          <ToggleInput
              v-model="historyInUTC"
              size="small"
          />
        </div>
      </div>
      <hr class="hidden sm:block" />
    </div>
    <div class="mt-twentyFive mb-xl">
      <TransitionGroup name="list-extend">
        <FeedItem
          v-for="(item, index) in displayList"
          :key="index"
          :item="item"
          :showGrayLine="showExtendLink || index !== displayList.length - 1"
          :historyInUTC="historyInUTC"
        />
      </TransitionGroup>
      <Transition name="list-extend">
        <div
          v-if="showExtendLink"
          key="extend-link"
          class="mt-sm pl-thirtyFive relative"
        >
          <div class="absolute left-none -top-4 w-twentyTwo h-twentyTwo rounded-full bg-whiteOverride border-signableBrandColours-midGrey border-solid border-1"></div>
          <div class="text-signableBrandColours-darkGrey text-14 sm:text-12 font-bold">
            {{ $tc('library.feeds.extendableFeed.extendLinkText.a', hiddenItemsCount) }}
            <button
              @click="extendDisplay"
              class="bg-transparent border-none p-none text-14 sm:text-12 text-signableBrandColours-darkGrey font-bold underline hover:text-primary cursor-pointer"
              data-test="extend-link"
              :data-ec="ec"
              data-et="extend_history_display_link"
            >
              {{ $tc('library.feeds.extendableFeed.extendLinkText.b', hiddenItemsCount, { amount: hiddenItemsCount, itemType: itemType })  }}
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import ToggleInput from '@/components/tailwind/forms/ToggleInput.vue';
import { FeedItem } from '@/components/library/feeds/FeedItem';

export default {
  name: 'ExtendableFeed',
  components: { ToggleInput, FeedItem },
  props: {
    extendable: Boolean,
    history: Array,
    title: String,
    itemType: String,
    ec: String,
  },
  data() {
    return {
      extended: false,
      historyInUTC: false,
    };
  },
  computed: {
    displayList() {
      // Reverse the order of the history to show latest events at the top
      // cloning history and using reverse because Test Utils does not like toReversed()
      // TODO use toReversed() here when we upgrade test utils
      const historyClone = [...this.history];
      const reverseHistory = historyClone.reverse();
      if (!this.extendable) {
        return reverseHistory;
      }
      if (!this.extended) {
        return reverseHistory.slice(0, 5);
      }
      return reverseHistory;
    },
    historyIsBrief() {
      return this.history.length <= 5;
    },
    showExtendLink() {
      if (!this.extendable || this.historyIsBrief) {
        return false;
      }
      return !this.extended;
    },
    hiddenItemsCount() {
      return this.history.length - 5;
    },
  },
  methods: {
    extendDisplay() {
      this.extended = true;
    },
  },
};
</script>

